import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { getMILESTONES } from './schedule_constants';
import { milestoneToTitle, formatDate } from '../../utils/';


const ReadonlySchedule = ({ schedule, divisionName }) => {
  if (_.isEmpty(schedule)) return null;

  const MILESTONES = getMILESTONES(divisionName);
  return (
    <div className="col s12">
      <div className="table-wrap">
        <table className="with-dates">
          <thead>
            <tr>
              <th>Milestone</th>
              <th>Original</th>
              <th>Projected</th>
              <th>Actual</th>
              <th>Design Baseline</th>
              <th>Construction Baseline</th>
              <th>Client Ext. Baseline</th>
            </tr>
          </thead>
          <tbody>
            { MILESTONES.map(key => {
              const row = schedule[key];
              return (
                <tr key={key}>
                  <td>{ milestoneToTitle(key, divisionName) }</td>
                  <td>{ formatDate(row.original)               }</td>
                  <td>{ formatDate(row.projected)              }</td>
                  <td>{ formatDate(row.actual)                 }</td>
                  <td>{ formatDate(row.designBaseline)         }</td>
                  <td>{ formatDate(row.constructionBaseline)   }</td>
                  <td>{ formatDate(row.clientExtendedBaseline) }</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

ReadonlySchedule.propTypes = {
  schedule: PropTypes.object.isRequired,
  divisionName: PropTypes.string.isRequired,
}

export default ReadonlySchedule;
